import {i18n, Icon} from 'mc/lib';
import {Static as StaticField} from 'mc/lib/field';
import FormField from 'mc/lib/field/FormField';
import PropTypes from 'prop-types';
import React from 'react';
import {Button, Card} from 'reactstrap';
import './TypZaborDetail.scss';

const fieldDecoration = {
    labelClass: {xs: 12, sm: 4, xl: 3},
    inputClass: {xs: 12, sm: 8, xl: 9},
    row: true,
    field: StaticField
};

const renderDruhUcel = (druhUcel, index) => (
    <span className="ucel" key={"ucel-" + index}>{druhUcel.nazev || druhUcel}</span>
);

const renderRoleSubjekt = (roleSubjekt, index) => (
    <li className="role" key={"roleSubjekt-" + index}>{roleSubjekt.nazev || roleSubjekt}</li>
);

const renderTypPriloha = (typPriloha, index) => (
    <li className="priloha" key={"typPriloha-" + index}>{typPriloha.nazev || typPriloha}</li>
);

const TypZaborDetail = ({typZabor}) => {
    const {druhUcelList, roleSubjektList, typPrilohaList, ikona, nazev, popis, urlDokumentPopis} = typZabor;

    return (
        <Card block className="typ-zabor-detail">
            <h2>Náležitosti žádosti <Icon icon="info-circle" className="pull-right" /></h2>
            <FormField name="typ" className="typ" label="Typ žádosti:" {...fieldDecoration}>
                <h4>
                    <img className="align-middle" src={serverContextPath + "/img/" + ikona}/>{' '}
                    <span className="align-middle">{nazev}</span>
                </h4>
            </FormField>
            <FormField name="popis" className="popis" label="Popis:" {...fieldDecoration}>
                {popis}
            </FormField>
            {druhUcelList && druhUcelList.length > 0 && (
                <FormField name="ucely" className="ucely" label="Účely:" {...fieldDecoration}>
                    {druhUcelList.map(renderDruhUcel)}
                </FormField>
            )}
            {urlDokumentPopis && (
                <FormField name="url" className="url" label="Url:" {...fieldDecoration}>
                    <Button color="link" onClick={() => window.open(urlDokumentPopis)}>{urlDokumentPopis}</Button>
                </FormField>
            )}
            <FormField name="role" className="role-list" label="Požadované informace:" {...fieldDecoration}>
                <ul>
                    <li>{i18n('typZabor.zadatel')}</li>
                    {roleSubjektList && roleSubjektList.map(renderRoleSubjekt)}
                </ul>
            </FormField>
            {typPrilohaList && typPrilohaList.length > 0 && (
                <FormField name="prilohy" className="prilohy" label="Požadované přílohy:" {...fieldDecoration}>
                    <ul>{typPrilohaList.map(renderTypPriloha)}</ul>
                </FormField>
            )}
        </Card>
    );
};

TypZaborDetail.propTypes = {
    typZabor: PropTypes.object.isRequired,
};

export default TypZaborDetail;
